import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { getTextStyle } from 'src/app/util/style-util'
import { ModalController, NavController } from '@ionic/angular';
import { AppRoutingUtil } from 'src/app/util/app-routing-util';
import { JobApplication, JobApplicationTerminalMessage, StyledText, StylingOption } from '@bluecrew/crew-member-backend-angular-client';

@Component({
  selector: 'app-post-submit',
  templateUrl: './post-submit.page.html',
  styleUrls: ['./post-submit.page.scss'],
})
export class PostSubmitPage implements OnInit {

  showAsFullPage: boolean;

  @Input() terminalMessage: JobApplicationTerminalMessage;
  @Input() jobApp: JobApplication;

  constructor(private modalCtrl: ModalController,
              private activatedRoute: ActivatedRoute,
              private navCtrl: NavController) {
    this.activatedRoute.queryParams.subscribe((result) => {
      this.showAsFullPage = result['showAsFullPage'];
      this.jobApp = result['jobApp']
    })
  }

  get headerIcon(): string {
    return this.showAsFullPage ? '/assets/icons/accept-job.svg': this.terminalMessage?.headerIcon;
  }

  get bodyText(): StyledText[] {
    return this.terminalMessage?.bodyText;
  }

  get showPosition(): boolean {
    return this.showAsFullPage ? true : this.terminalMessage?.showPosition;
  }

  get headerText(): string {
    return this.showAsFullPage ? 'You got the job!' : this.terminalMessage?.headerText;
  }

  get buttonText(): string {
    return this.showAsFullPage ? 'View Next Steps' : this.terminalMessage?.buttonText;
  }

  getTextStyle = getTextStyle;

  ngOnInit() {
  }

  /**
   * Determines whether or not to show the Blueshift list component
   * 
   * @returns true if:
   * 1. job application is a Blueshift application AND
   * 2. there is more than 1 job application acceptance status AND
   * 3. the acceptance statuses are not all equal
   */
  shouldShowBlueshiftStatusList(): boolean {
    return this.jobApp.isBlueshiftApplication &&
    this.jobApp.jobIdAndAcceptanceStatuses &&
    this.jobApp.jobIdAndAcceptanceStatuses.length > 1 &&
    !this.jobApp.jobIdAndAcceptanceStatuses.every(jobIdAndAcceptanceStatus =>
      jobIdAndAcceptanceStatus.acceptanceStatus === this.jobApp.jobIdAndAcceptanceStatuses[0].acceptanceStatus);
  }

  async onDismiss() {
    this.showAsFullPage ? await this.navCtrl.navigateForward(AppRoutingUtil.APP_STORE_LINKS, { queryParams: { showAsFullPage: true } })
    : await this.modalCtrl.dismiss(/* shouldGoToBrowseJobsPage */ false);
  }

  async onButtonClick() {
    await this.modalCtrl.dismiss(this.terminalMessage?.returnToJobsPage);
  }
}

